export const AKUTSCHUTZ_CANCELLATION_WITHIN_WITHDRAW_PERIOD =
  'akutschutz_cancellation_within_withdraw_period';
export const AKUTSCHUTZ_CANCELLATION_WITHIN_MINIMUM_DURATION =
  'akutschutz_cancellation_within_minimum_duration';
export const AKUTSCHUTZ_CANCELLATION_AFTER_MINIMUM_DURATION =
  'akutschutz_cancellation_after_minimum_duration';
